import dayjs from './dayjs'
import i18n from '../i18n'
import {format_currency, VND} from './function'

export default {
  install(Vue) {
    Vue.filter('moment', (value, format = 'DD-MM-YYYY') => {
      return value ? dayjs(new Date(value)).format(format) : ''
    })

    Vue.filter('timeFormat', function (input) {
      let date = new Date(input)
      let month = (date.getMonth() + 1)
      let day = date.getDate()
      let hour = date.getHours()
      let minute = date.getMinutes()
      return `${day < 10 ? '0' : ''}${day}-` +
        `${month < 10 ? '0' : ''}${month}` + '-' + date.getFullYear() + ' ' +
        `${hour < 10 ? '0' : ''}${hour}` + ':' +
        `${minute < 10 ? '0' : ''}${minute}`
    })

    Vue.filter('localDate', function (input) {
      let date = new Date(input)
      let month = (date.getMonth() + 1)
      let day = date.getDate()
      return `${day < 10 ? '0' : ''}${day}-` +
        `${month < 10 ? '0' : ''}${month}` + '-' + date.getFullYear()
    })

    Vue.filter('GENDER', function (input) {
      let data = [
        {
          code: 'MALE',
          value: i18n.t('base.male'),
        },
        {
          code: 'FEMALE',
          value: i18n.t('base.female'),
        },
        {
          code: 'DONT_KNOW',
          value: i18n.t('base.other'),
        },
      ]
      return data.filter(e => e.code === input).value || i18n.t('base.unknown')
    })

    Vue.filter('format_currency', format_currency)

    Vue.filter('currency', format_currency)

    Vue.filter('to_fixed', function (value, fixed = 1, default_value = 0) {
      if (!value) return default_value
      if (Number.isNaN(value)) return default_value
      if (typeof value.toFixed !== 'function') return default_value

      return +value.toFixed(fixed)
    })

    Vue.filter('VND', function (_number) {
      return VND(_number)
    })
  },
}



// WEBPACK FOOTER //
// ./src/addon/filter.js